import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { ReactNode } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  H3,
} from "@datapay-by-datacom/design-system";
import s from "./ErrorBoundary.module.css";

interface SimpleErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

function SimpleErrorFallback({
  error: _error,
  resetErrorBoundary,
}: SimpleErrorFallbackProps) {
  return (
    <div className={s.errorContainer}>
      <Card>
        <CardHeader>
          <H3>Something went wrong</H3>
        </CardHeader>
        <CardBody>
          <div className={s.cardContent}>
            <Button variant="primary" onPress={resetErrorBoundary}>
              Try again
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <ReactErrorBoundary
      FallbackComponent={SimpleErrorFallback}
      onError={(error) => console.error("Error caught:", error)}
    >
      {children}
    </ReactErrorBoundary>
  );
}
